import React, { useEffect } from "react"
import { BsPlusCircleFill } from "react-icons/bs"
import { useDividas } from "../../../../../../../context/DividasContext"
import { Emails, Telefones } from "../../../../../../../types/devedor-interface"
import { usePropostas } from "../../../../../../../context/PropostasContext"
import { useModal } from "../../../../../../../hooks/ModalContext"

interface CanaisEnvioProps {
  formaPag: string;
}

export const CanaisEnvio = ({ formaPag }: CanaisEnvioProps) => {
  const { devedorCadastro } = useDividas()
  const { getCanalEnvio, setEmailChecked, emailChecked, setSMSChecked, smsChecked } = usePropostas()
  const { setModal, modalInfo, onClose } = useModal();

  const listaSMS = devedorCadastro?.telefones?.telefonecliente && devedorCadastro?.telefones?.telefonecliente.length > 0 ? devedorCadastro?.telefones.telefonecliente.filter(item => (item.tipo_telefone.includes('Movel') && (item.situacaotelefone === 'Valido' || item.situacaotelefone === 'Contactado'))) : [] as Telefones[]

  const listaEmails = devedorCadastro?.emails?.emailcliente && devedorCadastro?.emails?.emailcliente?.length > 0 ? devedorCadastro?.emails.emailcliente.filter(item => item.situacaoemail.toLocaleUpperCase() === 'VALIDO' || item.situacaoemail.toLocaleUpperCase() === 'ATUALIZADO') : [] as Emails[]

  // console.log(devedorCadastro?.emails?.emailcliente)
  // useEffect(() => {

  // }, [devedorCadastro])

  function removerDuplicadosPorPropriedade(array: Telefones[]) {
    return array.filter((obj, index, self) =>
      index === self.findIndex((el) => el['telefone'] === obj['telefone'])
    );
  }

  function removerEmailDuplicadosPorPropriedade(array: Emails[]) {
    return array.filter((obj, index, self) =>
      index === self.findIndex((el) => el['email'] === obj['email'])
    );
  }

  const listaTelefone = listaSMS && listaSMS?.length > 0 ? removerDuplicadosPorPropriedade(listaSMS) : [] as Telefones[]
  const listaEmailsFiltrados = listaEmails && listaEmails?.length > 0 ? removerEmailDuplicadosPorPropriedade(listaEmails) : [] as Emails[]

  const radiosCss = 'flex items-center gap-1'

  function formatarTelefone(telefone: string) {
    telefone = telefone?.replace(/\D/g, '');
    telefone = telefone?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }

  useEffect(() => {
    //  if(emailChecked.isChecked && smsChecked.isChecked)
    if (listaEmailsFiltrados.length > 0 && !smsChecked.isChecked) {
      setEmailChecked({
        isChecked: true,
        value: listaEmailsFiltrados[0].email
      })
    } else {
      setEmailChecked({
        isChecked: false,
        value: ''
      })
      setSMSChecked({
        isChecked: true,
        value: listaTelefone[0].telefone
      })
    }
  }, [])

  useEffect(() => {
    if (!emailChecked.isChecked && !smsChecked.isChecked && listaEmailsFiltrados.length > 0) {
      setEmailChecked({
        isChecked: true,
        value: listaEmailsFiltrados.length > 0 ? listaEmailsFiltrados[0].email : ''
      })
    }
    if (!emailChecked.isChecked && smsChecked.isChecked && listaEmailsFiltrados.length > 0) {
      setSMSChecked({
        isChecked: true,
        value: listaTelefone[0].telefone
      })
    }

  }, [emailChecked.isChecked, smsChecked.isChecked])

  useEffect(() => {
    if (formaPag === 'PIX') {
      setEmailChecked({
        isChecked: true,
        value:
          listaEmailsFiltrados.length > 0 ? listaEmailsFiltrados[0].email : "",
      });
    }

    if (formaPag !== 'PIX' && listaEmailsFiltrados.length <= 0) {
      setEmailChecked({
        isChecked: false,
        value:
          listaEmailsFiltrados.length > 0 ? listaEmailsFiltrados[0].email : "",
      });
    }
  }, [formaPag])


  useEffect(() => {
    if (emailChecked.isChecked && smsChecked.isChecked) {
      getCanalEnvio({
        canalrecebimento: 'email;sms',
        destinorecebimento: `${emailChecked.value};${smsChecked.value}`
      })
    } else if (emailChecked.isChecked && !smsChecked.isChecked) {
      getCanalEnvio({
        canalrecebimento: 'email',
        destinorecebimento: `${emailChecked.value}`
      })
    } else if (!emailChecked.isChecked && smsChecked.isChecked) {
      getCanalEnvio({
        canalrecebimento: 'sms',
        destinorecebimento: `${smsChecked.value}`
      })
    }
  }, [emailChecked, smsChecked])


  function handleKeepChannel(e: React.ChangeEvent<HTMLInputElement>, type: string) {
    if (type === 'email') setEmailChecked({ isChecked: true, value: e.target.value })
    if (type === 'sms') {
      if ((emailChecked.isChecked && listaEmails.length === 1)) {
        setEmailChecked({
          isChecked: true,
          value: listaEmails[0].email
        })
      }
      setSMSChecked({ isChecked: true, value: e.target.value })
    }
    // canais.length === 2 ? handelEmailSMS(e.target.value, type) : handleChange(e)
  }

  return (
    <div className="flex flex-col text-sm border rounded-md p-2 border-gray-700 mb-4 text-gray-800">
      <strong className="font-medium text-sm">Para qual canal deseja enviar? </strong>
      <div className="flex items-center gap-4 my-2 text-xs">
        <div className={radiosCss}>
          <input name="email" type="checkbox" id="email"
            onClick={() => {
              if (listaEmailsFiltrados.length <= 0) {
                setEmailChecked({ isChecked: !emailChecked.isChecked, value: !emailChecked.isChecked && listaEmailsFiltrados.length > 0 ? listaEmailsFiltrados[0].email : '' })
              }
            }}
            // defaultChecked={emailChecked.isChecked}

            checked={emailChecked.isChecked}
          />
          <label htmlFor="email">E-mail</label>
        </div>
        {
          formaPag !== 'PIX' && (
            <div className={radiosCss}>
              <input
                name="sms"
                type="checkbox"
                onClick={() => {
                  if (listaEmailsFiltrados.length > 0) {
                    setSMSChecked({
                      isChecked: !smsChecked.isChecked,
                      value:
                        !smsChecked.isChecked && listaTelefone.length > 0
                          ? listaTelefone[0].telefone
                          : "",
                    });
                  }
                }}
                id="sms"
                // defaultChecked={smsChecked.isChecked}
                checked={smsChecked.isChecked}
              />
              <label htmlFor="sms">SMS</label>
            </div>
          )
        }

        {/* <div className={radiosCss}>
          <input name="whatsapp" type="checkbox" onClick={() => handleCanal('whatsapp')} id="whatsapp" />
          <label htmlFor="whatsapp">Whatsapp</label>
        </div> */}
      </div>



      <div className="flex items-start justify-between gap-4 w-full my-2">
        {
          (emailChecked.isChecked) && (
            <div className="border rounded-md p-2 border-primary min-w-[48%]">

              <div className="flex items-center justify-between px-2 mb-2">
                <p>Escolha o e-mail:</p>

                <button
                  className="ml-2 flex items-center justify-start gap-2 text-sm"
                  onClick={() => setModal("Adicionar E-mail", "Email")}
                >
                  {/* <img src={plusCircleIcon} alt="" /> */}
                  <BsPlusCircleFill className="fill-primary" size={20} />
                  Adicionar E-mail
                </button>
              </div>

              {
                emailChecked.isChecked && listaEmailsFiltrados && listaEmailsFiltrados?.length > 0 ? listaEmailsFiltrados?.map(emailMap => (
                  <div className={`${radiosCss} my-1`} key={emailMap.id_email}>
                    <input
                      onChange={(e) =>
                        handleKeepChannel(e, 'email')
                      }
                      // onClick={(e) =>  handleKeepChannel(e, 'email')}
                      type="radio"
                      name="email"
                      id={emailMap.id_email}
                      value={listaEmails.length === 1 ? listaEmails[0].email : emailMap.email}
                      defaultChecked={emailChecked.value === emailMap.email || listaEmails.length === 1}
                    />
                    <label htmlFor={emailMap.id_email}>{emailMap.email}</label>
                  </div>
                )) : (
                  <p>Não há emails cadastrados!</p>
                )
              }

            </div>

          )
        }

        {
          (smsChecked.isChecked && formaPag !== 'PIX') && (
            <div className="border rounded-md p-2 border-primary min-w-[48%]">
              <div className="flex items-center justify-between px-2 mb-2">
                <p>Escolha o SMS:</p>
                <button
                  className=" ml-2 flex  items-center justify-start gap-2 text-sm"
                  onClick={() => setModal("Adicionar Telefone", "Telefone")}
                >
                  {/* <img src={plusCircleIcon} alt="" /> */}
                  <BsPlusCircleFill className="fill-primary" size={20} />
                  Adicionar Telefone
                </button>
              </div>

              {
                listaTelefone && listaTelefone?.length > 0 ? listaTelefone?.map(tel => (
                  <div className={`${radiosCss} my-1`} key={tel.id_telefone}>
                    <input onChange={(e) => handleKeepChannel(e, 'sms')} type="radio" name="sms" id={tel.id_telefone} value={tel.telefone} defaultChecked={smsChecked.value === tel.telefone || listaSMS.length === 1} />
                    <label htmlFor={tel.id_telefone}>{formatarTelefone(tel.telefone)}</label>
                  </div>
                )) : (
                  <p>Não há telefones móveis cadastrados!</p>
                )
              }


            </div>


          )
        }

      </div>




    </div >
  )
}